module.exports = __webpack_public_path__ + "img/right-arrow.a5fd2dee.svg";